/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
import { __assign } from "tslib";
import { UnitsRepresentation } from '../units-representation';
import { ParamDefinition as PD } from '../../../mol-util/param-definition';
import { StructureRepresentationProvider, StructureRepresentationStateBuilder } from '../representation';
import { Representation } from '../../../mol-repr/representation';
import { OrientationEllipsoidMeshParams, OrientationEllipsoidMeshVisual } from '../visual/orientation-ellipsoid-mesh';
var OrientationVisuals = {
  'orientation-ellipsoid-mesh': function (ctx, getParams) {
    return UnitsRepresentation('Orientation ellipsoid mesh', ctx, getParams, OrientationEllipsoidMeshVisual);
  }
};
export var OrientationParams = __assign(__assign({}, OrientationEllipsoidMeshParams), {
  visuals: PD.MultiSelect(['orientation-ellipsoid-mesh'], PD.objectToOptions(OrientationVisuals))
});
export function getOrientationParams(ctx, structure) {
  return PD.clone(OrientationParams);
}
export function OrientationRepresentation(ctx, getParams) {
  return Representation.createMulti('Orientation', ctx, getParams, StructureRepresentationStateBuilder, OrientationVisuals);
}
export var OrientationRepresentationProvider = StructureRepresentationProvider({
  name: 'orientation',
  label: 'Orientation',
  description: 'Displays orientation ellipsoids for polymer chains.',
  factory: OrientationRepresentation,
  getParams: getOrientationParams,
  defaultValues: PD.getDefaultValues(OrientationParams),
  defaultColorTheme: {
    name: 'chain-id'
  },
  defaultSizeTheme: {
    name: 'uniform'
  },
  isApplicable: function (structure) {
    return structure.elementCount > 0;
  }
});